import React from 'react';

import type { SnackbarContextType } from './types';

const SnackbarContext = React.createContext<SnackbarContextType | null>(null);

export default SnackbarContext;
